// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__41oSS","balance__text":"Balance_balance__text__EC9bp","balance__amount":"Balance_balance__amount__W+RK8"};